import { ChangePasswordAdmin } from '../../components/admins/changePassword.component';

export const AdminChangePasswordPage = () => {
    return (
      <div className="row gx-0">
        <div className="col-12 m-2">
          <div className="d-flex flex-column ms-1 px-1">
            <p className="content-header">
              Change Password
            </p>
            <ChangePasswordAdmin/>
          </div>
        </div>
      </div>
    );
  };
  